import { Card, Col, Stack } from "react-bootstrap";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";

export default function SongsCard({ data, loading, error }) {
    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="offset-1 flex-grow-1">Songs</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Average muber of songs and unique songs played per day in time frame.</span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body>
                <Stack direction="horizontal">
                    {loading ? (
                        <LoadingIndicator width={85} />
                    ) : error ? (
                        <ErrorResponse errorCode={error} />
                    ) : (
                        <>
                            <Col>
                                <Stack>
                                    <span className="fw-bold fs-1 text-center">{data?.songs.time_frame ? data.songs.time_frame : "-"}</span>
                                    <span className="text-center fs-4">Songs</span>
                                    <span className="text-center text-muted fst-italic fs-6">
                                        <span>AVG </span>({data?.songs.average ? data.songs.average : "-"})
                                    </span>
                                </Stack>
                            </Col>
                            <div className="vr"></div>
                            <Col>
                                <Stack>
                                    <span className="fw-bold fs-1 text-center">{data?.unique_songs.time_frame ? data.unique_songs.time_frame : "-"}</span>
                                    <span className="text-center fs-4">Unique songs</span>
                                    <span className="text-center text-muted fst-italic fs-6">
                                        <span>AVG </span>({data?.unique_songs.average ? data.unique_songs.average : "-"})
                                    </span>
                                </Stack>
                            </Col>
                        </>
                    )}
                </Stack>
            </Card.Body>
        </Card>
    );
}
